<template>
    <div>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <ContactFormMainTab/>
        </v-tab-item>
        <v-tab-item>
          <ContactFormCompanyTab/>
        </v-tab-item>
        <v-tab-item>
          <ContactFormAddressTab/>
        </v-tab-item>
      </v-tabs-items>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactFormMainTab from '@/components/contacts/forms/contact/main_tab.vue'
import ContactFormCompanyTab from '@/components/contacts/forms/contact/company_tab.vue'
import ContactFormAddressTab from '@/components/contacts/forms/contact/address_tab.vue'
export default {
  name: 'contacts-form-fields',
  components: {
    ContactFormMainTab,
    ContactFormCompanyTab,
    ContactFormAddressTab
  },
  computed: {
    ...mapGetters({
      tabs: 'contacts/form/tabs',
      getContact: 'contacts/form/contact'
    }),
    contact: { get () { return this.getContact }, set (contact) { this.setContact(contact) } }
  },
  methods: {
    ...mapActions({
      setContact: 'contacts/form/setContact'
    })
  }
}
</script>

<style>

</style>
